import { render, staticRenderFns } from "./BrandListings.vue?vue&type=template&id=fec6b7ec&"
import script from "./BrandListings.vue?vue&type=script&lang=js&"
export * from "./BrandListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports